export default "__VITE_ASSET__e9d9ebef__"